const trades = /\/sellyourcar/gim;
const vdp2 = /\/vehicle\/(\d+)/gim;
const vdp1 = /\/search\/(\d{10})/gim;
const search = /\/(search|cars)/gim;
const vdp1Pending = /\/details\/(\w+)/gim;
const prequalify = /\/(get-approved|financing-prequalification)/gim;
const windowStickerBucket1 = /http:\/\/windowsticker.carvana.com/gim;
const windowStickerBucket2 = /amazonaws.com\/([A-HJ-NPR-Z0-9]{17}).pdf/gim;
const cvnaInfo = /cvna.info\//gim;
const pdf = /\.pdf$/gim;
const isCarvana = /https?:\/\/(www.)?carvana.com/gim;
const orderPlaced = /procurement\/order-placed-dashboard/gim;

enum PageType {
  Unknown,
  Trades,
  Vdp2,
  Vdp1,
  Financing,
  WindowSticker,
  Search,
  MobileSearch,
  PdfDocument,
  OrderPlacedDashboard,
}

const getPageType = (url: string) => {
  if (trades.test(url)) {
    return PageType.Trades;
  }
  if (vdp1.test(url)) {
    return PageType.Vdp1;
  }
  if (vdp2.test(url)) {
    return PageType.Vdp2;
  }
  if (search.test(url)) {
    return PageType.Search;
  }
  if (cvnaInfo.test(url)) {
    return PageType.MobileSearch;
  }
  if (vdp1Pending.test(url)) {
    return PageType.Vdp1;
  }
  if (prequalify.test(url)) {
    return PageType.Financing;
  }
  if (windowStickerBucket1.test(url) || windowStickerBucket2.test(url)) {
    return PageType.WindowSticker;
  }
  if (pdf.test(url)) {
    return PageType.PdfDocument;
  }
  if (orderPlaced.test(url)) {
    return PageType.OrderPlacedDashboard;
  }
  return PageType.Unknown;
};

const isCarvanaUrl = (url: string) => {
  return isCarvana.test(url) || cvnaInfo.test(url);
};

export { PageType, getPageType, isCarvanaUrl };
